import { getMinutesAndSecondsStringFromSeconds } from '../../DateTime';
import { isValidObject, isValidString } from '../../Validity';

export const rugbyPlayerGameDetails = (playerId: string, tries: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[], fouls: any[]) => {
    const details: any[] = [];
    if (isValidObject(tries)) {
        tries.forEach((rugbyTry: any) => {
            if (rugbyTry.team === 'our' && isValidString(rugbyTry.playerId) && rugbyTry.playerId === playerId) {
                details.push(`Try: ${getMinutesAndSecondsStringFromSeconds(rugbyTry.timeInSeconds)}`);
            }
            if (rugbyTry.team === 'our' && isValidString(rugbyTry.assistId) && rugbyTry.assistId === playerId) {
                details.push(`Try Assist: ${getMinutesAndSecondsStringFromSeconds(rugbyTry.timeInSeconds)}`);
            }
        });
    }

    if (isValidObject(conversions)) {
        conversions.forEach((conversion: any) => {
            if (conversion.team === 'our' && isValidString(conversion.playerId) && conversion.playerId === playerId) {
                details.push(`Conversion: ${getMinutesAndSecondsStringFromSeconds(conversion.timeInSeconds)}`);
            }
        });
    }

    if (isValidObject(penaltyKicks)) {
        penaltyKicks.forEach((penaltyKick: any) => {
            if (penaltyKick.team === 'our' && penaltyKick.convertedToGoal && isValidString(penaltyKick.playerId) && penaltyKick.playerId === playerId) {
                details.push(`Penalty Goal: ${getMinutesAndSecondsStringFromSeconds(penaltyKick.timeInSeconds)}`);
            }
        });
    }

    if (isValidObject(dropGoals)) {
        dropGoals.forEach((dropGoal: any) => {
            if (dropGoal.team === 'our' && isValidString(dropGoal.playerId) && dropGoal.playerId === playerId) {
                details.push(`Drop Goal: ${getMinutesAndSecondsStringFromSeconds(dropGoal.timeInSeconds)}`);
            }
        });
    }

    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            if (foul.team === 'our' && foul.yellowCard && isValidString(foul.playerId) && foul.playerId === playerId) {
                details.push(`Yellow Card: ${getMinutesAndSecondsStringFromSeconds(foul.timeInSeconds)}`);
            }
        });
    }

    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            if (foul.team === 'our' && foul.redCard && isValidString(foul.playerId) && foul.playerId === playerId) {
                details.push(`Red Card: ${getMinutesAndSecondsStringFromSeconds(foul.timeInSeconds)}`);
            }
        });
    }

    return details;
};
